export const VALIDATION = {
  fieldComplete: 'Le champs suivant doit être renseigné :',
  fieldsComplete: 'Les champs suivants doivent être renseignés :',
  notAccess: 'Vous n\'avez pas acccés à l\'application',
  referenceHavasInvalide: '[Spot Havas] La référence « {reference} » a été refusée : {detail}',
  stringLength: {
    fieldWithMin: 'Le champ "{name}" doit posséder entre {min} et {max} caractères.',
    intituleWithMinMax: 'Le champ "Intitule" de l\'adresse postale doit posséder entre {min} et {max} caractères.',
    adressVilleWithMinMax: 'Le champ "Ville" de l\'adresse postale doit posséder entre {min} et {max} caractères.',
    fieldWithMinIsOne: 'Le champ "{name}" est obligatoire.',
    field: 'Le champ "{name}" doit contenir moins de {max} caractères.',
  },
  requiredField: {
    libelle: 'Libellé',
  },
  latitude: 'Latitude',
  longitude: 'Longitude',
  password: 'Mot de passe',
  email: 'Email',
  site: 'Site',
};
